<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <weather v-if="weatherOpen && !isMobile" class="navbar-weather" />

    <div v-if="isLogin" class="right-menu">
      <div class="avatar-container">
        <el-dropdown
          @command="handleCommand"
          class="right-menu-item hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <img :src="avatar" class="user-avatar" />
            <el-icon><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <router-link to="/index" target="_blank">
                <el-dropdown-item>后台管理</el-dropdown-item>
              </router-link>
              <el-dropdown-item command="setLayout">
                <span>主题设置</span>
              </el-dropdown-item>
              <router-link to="/nav/edit" target="_blank">
                <el-dropdown-item>自定义导航</el-dropdown-item>
              </router-link>
              <router-link v-if="isMobile" to="/me" target="_blank">
                <el-dropdown-item>我的导航</el-dropdown-item>
              </router-link>
              <router-link
                to="/system/nav/edit"
                target="_blank"
                v-permission="['nav:category:site:edit']"
              >
                <el-dropdown-item>系统导航编辑</el-dropdown-item>
              </router-link>
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <div v-else class="right-menu-no-login">
      <el-button round @click="handleLoginClick">登录</el-button>
      <el-button v-if="!isMobile" type="primary" @click.stop="setLayout" round
        >主题</el-button
      >
    </div>

    <top-nav />

    <!-- 第三方登录弹窗 -->
    <login :visible="loginVisible" @close="handleLoginClose" />
  </div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { getToken } from '@/utils/auth'

import Hamburger from '@/components/Hamburger'
import Weather from '@/components/Weather'
import TopNav from '../TopNav'
import Login from '../Login'

const route = useRoute()
const store = useStore()
const avatar = computed(() => store.getters['user/avatar'])
const sidebar = computed(() => store.getters['app/sidebar'])
const weatherOpen = computed(() => store.getters['settings/weatherOpen'])
const isLogin = computed(() => getToken())
// 是否移动端
const isMobile = computed(() => store.getters['app/isMobile'])
const loginVisible = ref(false)

function toggleSideBar() {
  store.dispatch('app/toggleSideBar')
}

function handleCommand(command) {
  switch (command) {
    case 'setLayout':
      setLayout()
      break
    case 'logout':
      logout()
      break
    default:
      break
  }
}

function logout() {
  ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      store.dispatch('user/logout').then(() => {
        location.href = '/login?redirect=' + route.path
      })
    })
    .catch(() => {})
}

const emits = defineEmits(null)
function setLayout() {
  emits('setLayout')
}

/**
 * 点击登录操作
 */
function handleLoginClick() {
  loginVisible.value = true
}

/**
 * 登录弹窗关闭
 */
function handleLoginClose() {
  loginVisible.value = false
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .navbar-weather {
    float: left;
    margin: 15px;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  .right-menu-no-login {
    margin-right: 10px;
    height: 100%;
    line-height: 50px;
    float: right;
  }
}
</style>
